import { createApi } from "@reduxjs/toolkit/query/react";
import { createCustomFetchBaseQuery } from "../baseQuery";

export const courseApi = createApi({
  reducerPath: 'courseApi',
  baseQuery: createCustomFetchBaseQuery(),
  tagTypes: ['course'],
  endpoints: (builder) => ({
    getAllCourse: builder.query({
      query: ({ pageno, search, status ,sortOrder, sortBy ,disablePagination ,limit}) => {
        let url = `/admin/courses?pageno=${pageno}`;
        if (search) {
          url += `&search=${search}`;
        }
        if (status) {
          url += `&status=${status}`;
        }
        if (sortOrder) {
          url += `&sortOrder=${sortOrder}`;
        }
        if (sortBy) {
          url += `&sortBy=${sortBy}`;
        }
        if(disablePagination){
          url += `&disablePagination=true`;
        }
        if (limit) {
          url += `&limit=${limit}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['course'],
    }),
    getSingleCourse: builder.query({
      query: ({ id }) => {
        let url = `/admin/course/${id}`;
        return { url, method: 'GET' };
      },
      providesTags: ['course'],
    }),
    addCourse: builder.mutation({
      query: (data) => ({
        url: `/admin/course`,
        method: 'POST',
        body: data,
      }),
      invalidatesTags: ['course'],
    }),
    updateCourse: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/course/${id}`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['course'],
    }),
    updateCourseStatus: builder.mutation({
      query: ({ id, data }) => ({
        url: `/admin/course/${id}/status`,
        method: 'PUT',
        body: data,
      }),
      invalidatesTags: ['course'],
    }),
    getDetailCourse: builder.query({
      query: ({ id, year }) => {
        let url = `/admin/course/detail/${id}?year=${year}`;
        return { url, method: 'GET' };
      },
      providesTags: ['course'],
    }),
    deleteCourse: builder.mutation({
      query: ({ id }) => ({
        url: `/admin/course/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['course'],
    }),
    getCourse: builder.query({
      query: ({ pageno, search, category ,sortOrder, sortBy ,limit}) => {
        let url = `/contractor/courses?pageno=${pageno}`;
        if (search) {
          url += `&search=${search}`;
        }
        if (category) {
          url += `&category=${category}`;
        }
        if (sortOrder) {
          url += `&sortOrder=${sortOrder}`;
        }
        if (sortBy) {
          url += `&sortBy=${sortBy}`;
        }
        if (limit) {
          url += `&limit=${limit}`;
        }
        return {
          url,
          method: 'GET',
        };
      },
      providesTags: ['course'],
    }),
    getHomeDetailCourse: builder.query({
      query: ({ id }) => {
        let url = `/contractor/course/${id}`;
        return { url, method: 'GET' };
      },
      providesTags: ['course'],
    }),
    enrollCourse: builder.mutation({
      query: (id) => ({
        url: `/contractor/course/enroll/${id}`,
        method: 'POST',
      }),
      invalidatesTags: ['course'],
    }),
    getTopActiveAlerts: builder.query({
      query: () => {
        let url = `/contractor/alerts/top-active`;
        return { url, method: 'GET' };
      },
      providesTags: ['course'],
    }),
    reorderCourses: builder.mutation({
      query: ({ movedId, previousOrder, newOrder }) => ({
        url: `/admin/courses/reorder`,
        method: 'PUT',
        body: { movedId, previousOrder, newOrder },
      }),
      invalidatesTags: ['course'],
    }),
  }),
});

export const {
    useGetAllCourseQuery,
    useAddCourseMutation,
    useUpdateCourseMutation,
    useUpdateCourseStatusMutation,
    useGetSingleCourseQuery,
    useGetDetailCourseQuery,
    useDeleteCourseMutation,
    useGetCourseQuery,
    useGetHomeDetailCourseQuery,
    useEnrollCourseMutation,
    useGetTopActiveAlertsQuery,
    useReorderCoursesMutation,
} = courseApi;